<template>
  <div>
    <h2>Список пользователей без блокировки старых записей</h2>

    <el-row :gutter="10" style="margin-bottom: 10px">
      <el-col :span="6">
        <el-input
          v-model="newUsername"
          placeholder="Логин пользователя"
          @keyup.enter.native="addUser"
        ></el-input>
      </el-col>
      <el-col :span="6">
        <el-button @click="addUser" type="primary">Добавить</el-button>
      </el-col>
    </el-row>

    <el-table stripe border v-loading="loadData" :data="list">
      <el-table-column label="Логин" prop="username"></el-table-column>
      <el-table-column width="150" label="">
        <template slot-scope="raw">
          <el-button
            size="mini"
            @click="removeUser(raw.row.userId)"
            type="danger"
            >Удалить</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import notification from "@/mixins/notification";

export default {
  name: "oldRecordWhitelistMain",
  mixins: [notification],
  data() {
    return {
      loadData: true,
      newUsername: "",
    };
  },

  computed: {
    ...mapGetters({
      list: "GETOLDRECORDWHITELIST",
    }),
  },

  methods: {
    async loadList() {
      this.loadData = true;
      await this.$store.dispatch("getOldRecordWhitelist");
      this.loadData = false;
    },

    async addUser() {
      if (!this.newUsername) {
        return;
      }
      await this.$store
        .dispatch("setPermissionForUser", 
          { 
            userIdOrName:this.newUsername, 
            permissionName: "record_unlock", 
            permissionState: true
          })
        .then(async () => {
          this.newUsername = "";
          this.notification("Успешно", "Пользователь добавлен", "success");
          await this.loadList();
        })
        .catch((error) => {
          this.message(
            error.response && error.response.data
              ? error.response.data
              : "Не удалось добавить пользователя",
            "error",
            true
          );
        });
    },

    removeUser(userId) {
      this.confirm(
        "Удалить пользователя из списка?",
        "Вы уверены что хотите убрать пользователя из списка исключений",
        "warning",
        "Удалить",
        "Отмена"
      )
        .then(async () => {
          await this.$store.dispatch("setPermissionForUser",
          { 
            userIdOrName:userId, 
            permissionName: "record_unlock", 
            permissionState: false
          });
          this.notification("Успешно", "Пользователь удален", "success");
          await this.loadList();
        })
        .catch(() => {});
    },
  },

  async mounted() {
    await this.loadList();
  },
};
</script>

<style scoped></style>
